import { logError } from '@klarna-web-sdk/utils/src/logger'

import { ValidationError } from '../../errors'

export function handleValidationError(message: string) {
  logError(message)
  throw new ValidationError(message)
}
